import { render, staticRenderFns } from "./BotonDesacargaCSV.vue?vue&type=template&id=be4f6924&scoped=true"
import script from "./BotonDesacargaCSV.vue?vue&type=script&lang=js"
export * from "./BotonDesacargaCSV.vue?vue&type=script&lang=js"
import style0 from "./BotonDesacargaCSV.vue?vue&type=style&index=0&id=be4f6924&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be4f6924",
  null
  
)

export default component.exports